import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './mixins'
import ElementUI from 'element-ui'
import 'css/base/element_theme.scss'
import 'ant-design-vue/dist/antd.less'
// import antDesignVue from 'ant-design-vue'
import { Tree, Spin, Dropdown, Icon, Input, InputNumber, Form, Button, Modal, Switch, Menu } from 'ant-design-vue';

// import 'xe-utils'
import XEUtils from 'xe-utils'
import VXEUtils from 'vxe-utils'
import VXETable from 'vxe-table'
// const VXETable=() => import("vxe-table");
import 'vxe-table/lib/style.css'
import VXETablePluginAntd from 'vxe-table-plugin-antd'
import 'vxe-table-plugin-antd/dist/style.css'
// 自定义公共方法
import common from '@/common'

Vue.use(Tree)
Vue.use(Spin)
Vue.use(Dropdown)
Vue.use(Icon)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Form)
Vue.use(Button)
Vue.use(Modal)
Vue.use(Switch)
Vue.use(Menu)

Vue.use(ElementUI)
Vue.use(VXEUtils, XEUtils, { mounts: ['cookie'] })
VXETable.use(VXETablePluginAntd)
Vue.use(VXETable)

// Vue.use(KFormDesign)
Vue.config.productionTip = false
Vue.prototype.common = common

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
